import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import Select from 'components/Select'
import { FormItem } from 'components/UIComponents/FormStyles'
import CloseIcon from 'components/icons/CloseIcon'
import DeleteIcon from 'components/icons/Delete'
import React from 'react'
import isValidUUID from 'utils/isValidUUID'
import { EmptySpanElement } from '../../../../../../components/UIComponents/CommonStyledComponent'
import { DeleteButton, MulitiSlectbox } from './Styles'

function CommonSkillAndOr({
  index = null,
  label,
  note,
  onDelete,
  handleSelectChange,
  OptionData,
  onSearch,
  AndORname,
  skillName,
  value,
  handleDropdownVisibleChange,
  isEditRoleOnView,
  autoClearSearchValue,
  allowClear,
  lastValue,
  symbol,
  selectedLength,
  mandatorySkillCount,
  note1,
  isDelete = false,
  required,
  disabled,
  border,
  isFieldsMandatory = false,
  selectFieldDisabled,
  searchValue,
  ...props
}) {
  const renderTag = option => {
    return (
      !isValidUUID(option.label) && (
        <div
          className="ant-select-selection-overflow-item"
          style={{
            position: 'relative',
            opacity: 1,
            display: 'flex',
          }}
        >
          <span className="ant-select-selection-item ant-select-selection-item-disabled ">
            <span className="ant-select-selection-item-content">
              {option.label}
            </span>
            {!option.disabled && option.closable && (
              <EmptySpanElement
                onClick={option.onClose}
                style={{ userSelect: 'none', cursor: 'pointer' }}
              >
                <CloseIcon />
              </EmptySpanElement>
            )}
          </span>
          {option.value !== lastValue && (
            <span
              style={{
                padding: '8px',
              }}
            >
              {symbol === 'AND' ? '&' : symbol === 'OR' ? 'OR' : ''}
            </span>
          )}
        </div>
      )
    )
  }
  return (
    <MulitiSlectbox>
      <div style={{ width: onDelete ? '90%' : '100%' }}>
        <FormItem
          name={skillName}
          rules={[
            {
              validator: (_, value) => {
                if ((selectedLength ?? 0) > 15) {
                  return Promise.reject(
                    new Error(`Skill should not exceed 15 skills`)
                  )
                }
                return Promise.resolve()
              },
            },
          ]}
        >
          <Select
            showArrow={true}
            showSearch={true}
            mode="multiple"
            // mode="tags"
            placeholder="Select Skills"
            valueParam="id"
            optionFilterProp="name"
            onSearch={onSearch}
            OptionData={OptionData}
            // onChange={handleSelectChange}
            onChange={(value, newValue) => {
              handleSelectChange(value, newValue)
            }}
            filterOption={false}
            customOptions={isEditRoleOnView}
            selectedOptions={value.skills ?? []}
            onDropdownVisibleChange={handleDropdownVisibleChange}
            tagRender={(option, index) => renderTag(option)}
            autoClearSearchValue={true}
            allowClear={!isEditRoleOnView}
            listHeight={170}
            disabled={selectFieldDisabled}
            searchValue={searchValue}
          />
        </FormItem>
        {selectedLength ? (
          <Flex right>
            <Label>
              {selectedLength}/{mandatorySkillCount}
            </Label>
          </Flex>
        ) : null}
      </div>
      {isDelete && onDelete && (
        <DeleteButton
          onClick={() => onDelete(index)}
          width="10%"
          border={selectedLength > 0 ? '' : border}
        >
          <DeleteIcon />
        </DeleteButton>
      )}
    </MulitiSlectbox>
  )
}

export default CommonSkillAndOr
